export default __webpack_public_path__ + "static/feature7-f29d2b65d066d396b60ddc229303c3ea.webp";